import { GetStaticProps } from 'next'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

import ENV_VARS from '@/config'
import { makeMainLayout } from '@/layouts/main'
import BlackFridayEnterprise from '@/features/BlackFridayPromotions/enterprise'
import { HeaderTheme } from '@/features/Header'
import Head from '@/components/head'

const { BASE_URL } = ENV_VARS

function HalifaxLandlords() {
  const { t } = useTranslation('landlords')

  return (
    <>
      <Head
        title={t('landlords:Holiday Sale For Landlords | liv.rent')}
        description={t(
          `landlords:Special Holiday promotion for landlords. Get 30% off the Enterprise plan, which includes 50 Fb Marketplace ads, 15 tenant screening credits, and much more!`
        )}
        meta={{
          image: `${BASE_URL}/images/holiday-landlords-offers-liv.rent.jpg`,
          imageAlt: t('landlords:Holiday Landlords Offers Liv.rent')
        }}
        path="/landlords/promotions/enterprise"
      ></Head>
      <BlackFridayEnterprise />
    </>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale = '' }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['translation', 'landlords']))
    }
  }
}
const headerConfig = {
  theme: HeaderTheme.TRANSPARENT,
  showNavItems: true,
  showSearch: false
}

HalifaxLandlords.Layout = makeMainLayout({ headerConfig })

export default HalifaxLandlords
